import { useBlockedActionsContext } from "@app/components/assistant/conversation/BlockedActionsProvider";
import { useConversationSidePanelContext } from "@app/components/assistant/conversation/ConversationSidePanelContext";
import { MCPToolValidationRequired } from "@app/components/assistant/conversation/MCPToolValidationRequired";
import { AppLayoutTitle } from "@app/components/sparkle/AppLayoutTitle";
import { useAuth } from "@app/lib/auth/AuthContext";
import type { ConversationWithoutContentType } from "@app/types/assistant/conversation";
import type { LightWorkspaceType } from "@app/types/user";
import { Button, CheckCircle, Icon, XClose } from "@dust-tt/sparkle";

interface ToolReviewPanelProps {
  conversation: ConversationWithoutContentType;
  owner: LightWorkspaceType;
}

export function ToolReviewPanel({ conversation, owner }: ToolReviewPanelProps) {
  const { user } = useAuth();
  const { data: actionId, closePanel } = useConversationSidePanelContext();
  const { getBlockedActions } = useBlockedActionsContext();

  const blockedAction = user
    ? getBlockedActions(user.sId).find(
        (action) =>
          action.actionId === actionId &&
          action.status === "blocked_validation_required"
      )
    : undefined;

  return (
    <div className="flex h-panel flex-col">
      <AppLayoutTitle>
        <div className="flex h-full items-center justify-between gap-3">
          <span className="truncate text-sm font-semibold text-foreground">
            Review before it goes out
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={closePanel}
            icon={XClose}
          />
        </div>
      </AppLayoutTitle>
      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">
        {blockedAction?.status === "blocked_validation_required" ? (
          <MCPToolValidationRequired
            presentation="panel"
            triggeringUser={null}
            owner={owner}
            blockedAction={blockedAction}
            conversationId={conversation.sId}
            onResolved={closePanel}
          />
        ) : (
          <div className="flex h-full flex-col items-center justify-center gap-2 text-center text-sm text-muted-foreground">
            <Icon visual={CheckCircle} size="md" />
            Nothing is waiting for your review here anymore.
          </div>
        )}
      </div>
    </div>
  );
}
